import React from "react";
import * as PropTypes from "prop-types";
import Select from "react-select";
import { MemberDropdownChakra } from "./MemberDropdown";
import RemoveButtonGroup from "./RemoveButtonGroup";
import FilterInput from "./FilterInput";
import { AiOutlinePlus } from "react-icons/ai";
const FilterGroup = ({
  members,
  availableMembers,
  addMemberName,
  updateMethods
}) => (
  <span>
    {members.map((m) => (
      <div
        style={{
          marginBottom: 12
        }}
        key={m.index}
      >
        <RemoveButtonGroup onRemoveClick={() => updateMethods.remove(m)}>
          <MemberDropdownChakra
            onClick={(updateWith) =>
              updateMethods.update(m, {
                ...m,
                dimension: updateWith
              })
            }
            availableMembers={availableMembers}
            style={{
              width: 150,
              textOverflow: "ellipsis",
              overflow: "hidden"
            }}
          >
            {m.dimension.title}
          </MemberDropdownChakra>
        </RemoveButtonGroup>
        <Select
          value={m.operator}
          onChange={(operator) =>
            updateMethods.update(m, {
              ...m,
              operator
            })
          }
          style={{
            width: 200,
            marginRight: 8
          }}
          options={m.operators.map((operator) => ({
            value: operator.name,
            label: operator.title
          }))}
        />
        <FilterInput
          member={m}
          key="filterInput"
          updateMethods={updateMethods}
        />
      </div>
    ))}
    <MemberDropdownChakra
      onClick={(m) =>
        updateMethods.add({
          dimension: m
        })
      }
      availableMembers={availableMembers}
      type="dashed"
      icon={<AiOutlinePlus />}
    >
      {addMemberName}
    </MemberDropdownChakra>
  </span>
);
FilterGroup.propTypes = {
  members: PropTypes.array.isRequired,
  availableMembers: PropTypes.array.isRequired,
  addMemberName: PropTypes.string.isRequired,
  updateMethods: PropTypes.object.isRequired
};
export default FilterGroup;
